export const RECAPTCHA_ACTIONS = {
  login: 'LOGIN',
  signup: 'SIGNUP',
  forgotPassword: 'FORGOT_PASSWORD', // NOSONAR - public reCAPTCHA action name, not a secret.
  rfq: 'RFQ',
} as const;

export type RecaptchaAction = (typeof RECAPTCHA_ACTIONS)[keyof typeof RECAPTCHA_ACTIONS];
